<template>
  <li v-if="post">
    <div class="post-body">
      <div class="image" v-if="post && post.social === 'FB'">
        <iframe
          v-if="post && post.hasVideo && post.attach && post.attach.length"
          :src="
            'https://www.facebook.com/plugins/video.php?href=' +
            post.attach[0].video_url +
            '&amp;width=500&amp;show_text=false&amp;appId=227160864129868&amp;height=281'
          "
          width="100%"
          height="auto"
          style="border: none; overflow: hidden"
          scrolling="no"
          frameborder="0"
          allowtransparency="true"
        ></iframe>

          <collage
            :items="imageAttach"
            :className="'paper-collage'"
            :padding="5"
            :tuid="randomHash"
            :befLoad="onBeforeLoad(post)"
            v-if="imageAttach.length >= 1"
          />
      </div>      
      <div class="image" v-if="post && post.social === 'VK'">
        <collage
          :items="imageAttach"
          :className="'paper-collage'"
          :padding="5"
          :tuid="randomHash"
          :befLoad="onBeforeLoad(post)"
          v-if="imageAttach.length >= 1"
        />

        <iframe v-if="videoAttach.length == 1" :src="`https://vk.ru/video_ext.php?oid=${videoAttach[0].owner_id}&id=${videoAttach[0].video_id}&hd=2`" width="853" height="480" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen></iframe>
      </div>
      <div class="image" v-if="post && post.social === 'IG'">
        <collage
          :items="allMediaAttach"
          :className="'paper-collage'"
          :padding="5"
          :tuid="randomHash"
          :befLoad="onBeforeLoad(post)"
          v-if="allMediaAttach.length >= 1 && !showIgEmbed"
          @video-error="onCollageMediaError"
          @photo-error="onCollageMediaError"
        />
        <Cm-ig-embed v-if="showIgEmbed" :url="post.link" />
      </div>
      <div class="image" v-if="post && post.social === 'TG'">
        <!-- Заглушка до загрузки медиа -->
        <div 
          v-if="hasTelegramAttachments && !telegramMediaLoaded && !telegramMediaLoading"
          class="tg-media-placeholder"
          :style="{ background: telegramGradient }"
          @click="loadTelegramMedia"
        >
          <div class="placeholder-content">
            <div class="placeholder-icons">
              <i v-if="hasPhotos" class="bi bi-image"></i>
              <i v-if="hasVideos" class="bi bi-play-circle"></i>
            </div>
            <span class="placeholder-text">{{ placeholderText }}</span>
            <span class="placeholder-hint">{{ $t('TG_LOAD_MEDIA') }}</span>
          </div>
        </div>
        <!-- Индикатор загрузки -->
        <div v-else-if="telegramMediaLoading" class="tg-media-loading">
          <div class="loading-spinner"></div>
          <span>{{ $t('TG_LOADING_MEDIA') }}</span>
        </div>
        <!-- Ошибка загрузки -->
        <div 
          v-else-if="telegramMediaError && !telegramMediaLoaded" 
          class="tg-media-error"
          @click="retryLoadTelegramMedia"
        >
          <i class="bi bi-exclamation-triangle"></i>
          <span>{{ $t('TG_ERROR_LOAD_MEDIA') }}</span>
          <span class="placeholder-hint">{{ $t('TG_RETRY_LOAD_MEDIA') }}</span>
        </div>
        <!-- Загруженные медиа -->
        <collage
          :items="allMediaAttach"
          :className="'paper-collage'"
          :padding="5"
          :tuid="randomHash"
          :befLoad="onBeforeLoad(post)"
          v-else-if="telegramMediaLoaded && allMediaAttach.length >= 1"
        />
      </div>
      <div class="text" v-if="post">
        <a class="date" :href="post.link" target="_blank" v-if="post.link">
          {{ getTime }}
          <mod>{{ getDate }}</mod>
        </a>
        <p class="post-text">
          <span v-if="showText" v-html="showText"></span>
          <span
            class="more"
            v-if="post && post.textCanShowMore && post.post_id && !getPostTextShowMap[post.post_id]"
            @click="DASH_POST_SHOW_TEXT(post.post_id)"
            >{{ $t('POST_MORE') }}</span
          >
          <span
            class="more"
            v-if="post && post.textCanShowMore && post.post_id && getPostTextShowMap[post.post_id]"
            @click="DASH_POST_SHOW_TEXT(post.post_id)"
            >{{ $t('POST_LESS') }}</span
          >
        </p>
      </div>
    </div>
    
    <div class="m-tech" v-if="post && post.formatedStats">
      <div class="reactions" v-if="post.formatedStats.total">
        <div class="react-metric"
          :key="`${value}${post.local_id / 100}${post.page_id}${key}`"
          v-for="(value, key) in post.formatedStats.total"
        >
          <span>
            <i :class="`bi ${reactionIcons[key]}`"></i>
          </span>

          {{ value }}
        </div>
      </div>

      <div class="engagement" v-if="post.formatedStats.engagement">
        <div class="react-metric"
          :key="`${post.local_id}${value}${key}`"
          v-for="(value, key) in post.formatedStats.engagement"
        >
          <span>{{ $t("POSTS_FEED_" + key.toUpperCase()) }}</span>
          {{ value }}
        </div>
      </div>
    </div>
  </li>
  <li v-else class="post-error">
    <!-- Empty placeholder for invalid post -->
  </li>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Collage from "./Collage";
import CmIgEmbed from "../ContentMonitoring/Cm-ig-embed";
import TelegramMedia from "../../../api/controllers/telegram-media";
import { ERROR_PLACEHOLDER } from "../../../utils/telegram-placeholders";

import "glightbox/dist/css/glightbox.css";

import {
  DASH_UPDATE_ATTACHES,
  DASH_POST_SHOW_TEXT,
} from "@/store/actions/dash";

export default {
  name: "Dash-post-card",
  components: {
    Collage,
    CmIgEmbed,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    page: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      telegramMediaLoaded: false,
      telegramMediaLoading: false,
      telegramMediaError: false,
      processedAttachments: null,
      brokenMedia: {},
    };
  },
  watch: {
    "post.post_id"() {
      this.brokenMedia = {};
    },
  },
  mounted() {
    // Медиа загружается только по клику пользователя
  },
  computed: {
    ...mapGetters(["getPostTextShowMap"]),
    // Проверяем есть ли Telegram вложения
    hasTelegramAttachments() {
      return this.post?.social === 'TG' && 
             this.post?.attach && 
             Array.isArray(this.post.attach) && 
             this.post.attach.length > 0;
    },
    telegramGradient() {
      const gradients = [
        'linear-gradient(135deg, #2E5274, #673AB7)',
        'linear-gradient(135deg, #006699, #3F51B5)',
        'linear-gradient(135deg, #097ad4, #9D25D6)',
        'linear-gradient(135deg, #2850A7, #e7174e)',
        'linear-gradient(135deg, #3c50a9, #00d09c)',
        'linear-gradient(135deg, #4859bb, #D13379)',
      ];
      const index = (this.post?.post_id || 0) % gradients.length;
      return gradients[index];
    },
    // Есть ли фото во вложениях
    hasPhotos() {
      if (!this.hasTelegramAttachments) return false;
      return this.post.attach.some(item => item.type === 'photo');
    },
    // Есть ли видео во вложениях
    hasVideos() {
      if (!this.hasTelegramAttachments) return false;
      return this.post.attach.some(item => item.type === 'video');
    },
    // Текст для заглушки
    placeholderText() {
      if (!this.hasTelegramAttachments) return '';
      const count = this.post.attach.length;
      const photoCount = this.post.attach.filter(i => i.type === 'photo').length;
      const videoCount = this.post.attach.filter(i => i.type === 'video').length;
      
      const parts = [];
      if (photoCount > 0) {
        parts.push(`${photoCount} ${this.$t('MEDIA_PHOTO')}`);
      }
      if (videoCount > 0) {
        parts.push(`${videoCount} ${this.$t('MEDIA_VIDEO')}`);
      }
      return parts.join(` ${this.$t('MEDIA_AND')} `) || `${count} ${this.$t('MEDIA_ITEMS')}`;
    },
    // Получаем актуальные attachments (либо обработанные, либо оригинальные)
    currentAttachments() {
      return this.processedAttachments || this.post?.attach || [];
    },
    showText() {
      if (!this.post || typeof this.post !== 'object') {
        return '';
      }
      
      let text = "";
      if (this.post.hasText) {
        if (
          this.post.textCanShowMore &&
          this.getPostTextShowMap[this.post.post_id]
        ) {
          text = this.post.text || "";
        } else if (
          this.post.textCanShowMore &&
          !this.getPostTextShowMap[this.post.post_id]
        ) {
          text = this.post.small_text || "";
        } else {
          text = this.post.text || "";
        }
      }

      // Only perform replacements if text is not empty
      if (text) {
        text = text.replace(/(https?:\/\/[^\s]+)/g, (match) => {
          return `<a class="link-hover" href="${match}" target="_blank">${match}</a>`;
        });

        text = text.replace(
          /\[([^\|\]]+)\|([^\]]+)\]/g,
          (match, id, label) => {
            return `<a class="link-hover" href="https://vk.com/${id}" target="_blank">${label}</a>`;
          }
        );
        
        // Обработка упоминаний @username для Instagram и Telegram
        if (this.post.social === 'IG') {
          text = text.replace(
            /(\s)@([A-Za-z0-9._]+)/g,
            (match, space, username) => {
              return `${space}<a class="link-hover" href="https://instagram.com/${username}" target="_blank">@${username}</a>`;
            }
          );
        } else if (this.post.social === 'TG') {
          text = text.replace(
            /(\s)@([A-Za-z0-9._]+)/g,
            (match, space, username) => {
              return `${space}<a class="link-hover" href="https://t.me/${username}" target="_blank">@${username}</a>`;
            }
          );
        }
      }

      return text;
    },
    imageAttach() {
      return this.currentAttachments.filter((item) => item.type == "photo") || [];
    },
    videoAttach() {
      return this.currentAttachments.filter((item) => item.type == "video") || [];
    },
    allMediaAttach() {
      if (!this.currentAttachments.length) return [];
      
      // For Instagram and Telegram, combine photos and videos for collage display
      if (this.post.social === 'IG' || this.post.social === 'TG') {
        const mediaItems = this.currentAttachments.map(item => {
          // Convert reactive objects to plain objects
          const plainItem = JSON.parse(JSON.stringify(item));
          
          const embed = this.post.social === "IG" ? (this.post.link || "") : "";
          if (plainItem.type === 'video') {
            return {
              type: 'video',
              image_url: plainItem.video_url, // Use video URL as source for poster
              video_url: plainItem.video_url,
              embed_url: embed,
              post_url: embed,
              loading: plainItem.loading || false
            };
          }
          return {
            type: 'photo',
            image_url: plainItem.image_url,
            embed_url: embed,
            post_url: embed,
            loading: plainItem.loading || false
          };
        });
        
        // Remove duplicates based on image_url
        const uniqueItems = [];
        const seenUrls = new Set();
        
        for (const item of mediaItems) {
          if (item.image_url && !seenUrls.has(item.image_url)) {
            seenUrls.add(item.image_url);
            uniqueItems.push(item);
          }
        }
        
        return uniqueItems;
      }
      
      // For other social networks, return photos only (existing behavior)
      return this.imageAttach;
    },
    igEmbedUrl() {
      const link = (this.post && this.post.link) || "";
      return /instagram\.com\/(reel|p|tv)\//i.test(link) ? link : "";
    },
    showIgEmbed() {
      if (!this.igEmbedUrl || this.post.social !== "IG") return false;
      const items = this.allMediaAttach;
      if (!items.length) return false;
      if (items.length === 1 && items[0].type === "video" && this.brokenMedia[0]) return true;
      return items.every((_, i) => this.brokenMedia[i]);
    },

    getTime() {
      if (!this.post || !this.post.date || !(this.post.date instanceof Date)) {
        return "";
      }
      return `${this.post.date.getHours()}:${
        (this.post.date.getMinutes() < 10 ? "0" : "") +
        this.post.date.getMinutes()
      }`;
    },
    getDate() {
      if (!this.post || !this.post.date || !(this.post.date instanceof Date)) {
        return "";
      }
      return this.moment(this.post.date).format("DD/MM/YYYY");
    },
    reactionIcons() {
      return {
        likes: "bi-heart",
        shares: "bi-arrow-return-left",
        comments: "bi-chat-right-dots",
        views: "bi-eye",
        er: "bi-heart",
        er_views: "bi-heart",
        ir: "bi-heart",
      };
    },
    randomHash() {
      return Math.random().toString(36).substr(2, 8);
    },
  },
  methods: {
    ...mapActions([DASH_UPDATE_ATTACHES]),
    ...mapMutations([DASH_POST_SHOW_TEXT]),
    onCollageMediaError(_item, idx) {
      if (idx == null || idx < 0) return;
      this.$set(this.brokenMedia, idx, true);
    },
    async onError(event, post, attachNum) {
      if (!post) return;
      event.target.src = await this.DASH_UPDATE_ATTACHES({ post, attachNum });
    },

    onBeforeLoad: (post) => {
      if (!post) return () => {};
      return () => {
        // Implementation for loaded slides
      };
    },

    /**
     * Повторная попытка загрузки медиа
     */
    retryLoadTelegramMedia() {
      this.telegramMediaError = false;
      this.loadTelegramMedia();
    },

    /**
     * Загружает Telegram медиа файлы через API
     * Для каждого attach делает отдельный запрос с его message_id
     * Вызывается только по клику пользователя
     */
    async loadTelegramMedia() {
      if (!this.post?.attach || !Array.isArray(this.post.attach)) {
        return;
      }

      const username = this.page?.owner_domain;

      if (!username) {
        console.error('[TG Post] Missing username for Telegram media request');
        return;
      }

      // Устанавливаем состояние загрузки
      this.telegramMediaLoading = true;
      this.telegramMediaError = false;

      // Создаем копию attachments для обработки
      const processedAttach = JSON.parse(JSON.stringify(this.post.attach));
      const attachCount = processedAttach.length;

      console.log(`[TG Post] Loading ${attachCount} media files for @${username}`);

      // Загружаем каждое медиа параллельно по его message_id
      const loadPromises = processedAttach.map(async (attach, index) => {
        // Используем message_id из attach, или post_id как fallback
        const messageId = attach.message_id || this.post.post_id;
        
        if (!messageId) {
          console.error(`[TG Post] No message_id for attach at index ${index}`);
          return { index, success: false, error: 'No message_id' };
        }

        console.log(`[TG Post] Loading media ${index + 1}/${attachCount}: message_id=${messageId}`);

        try {
          const response = await TelegramMedia.getTelegramMedia({
            username,
            messageId
          });

          // Извлекаем медиа из ответа
          // Формат: { success: true, data: { media: [...], message_id } }
          const mediaItems = response?.data?.media || response?.media || [];
          const mediaItem = Array.isArray(mediaItems) ? mediaItems[0] : null;

          let mediaUrl = null;

          if (mediaItem) {
            // API возвращает base64 в поле "data" или готовый URL
            mediaUrl = mediaItem.url || mediaItem.image_url || mediaItem.video_url;
            
            // Если есть поле data с base64 - конвертируем в data URL
            if (!mediaUrl && mediaItem.data) {
              const mimeType = mediaItem.type === 'video' ? 'video/mp4' : 'image/jpeg';
              mediaUrl = `data:${mimeType};base64,${mediaItem.data}`;
            }
          }

          if (mediaUrl) {
            console.log(`[TG Post] Media ${index + 1} loaded successfully`);
            return { index, success: true, url: mediaUrl, type: attach.type };
          } else {
            console.warn(`[TG Post] No media URL in response for index ${index}`);
            return { index, success: false, error: 'No media URL in response' };
          }

        } catch (error) {
          console.error(`[TG Post] Failed to load media ${index + 1}:`, error);
          return { index, success: false, error: error.message };
        }
      });

      // Ждем завершения всех запросов
      const results = await Promise.all(loadPromises);

      // Обрабатываем результаты
      let hasErrors = false;
      results.forEach(result => {
        if (result.success && result.url) {
          processedAttach[result.index].loading = false;
          processedAttach[result.index].error = null;
          
          if (processedAttach[result.index].type === 'video') {
            processedAttach[result.index].video_url = result.url;
          } else {
            processedAttach[result.index].image_url = result.url;
          }
        } else {
          hasErrors = true;
          processedAttach[result.index].loading = false;
          processedAttach[result.index].error = result.error;
          
          if (processedAttach[result.index].type === 'photo') {
            processedAttach[result.index].image_url = ERROR_PLACEHOLDER;
          } else if (processedAttach[result.index].type === 'video') {
            processedAttach[result.index].video_url = ERROR_PLACEHOLDER;
          }
        }
      });

      this.processedAttachments = [...processedAttach];
      this.telegramMediaLoaded = true;
      this.telegramMediaLoading = false;
      this.telegramMediaError = hasErrors && results.every(r => !r.success);

      const successCount = results.filter(r => r.success).length;
      console.log(`[TG Post] Loaded ${successCount}/${attachCount} media files for @${username}`);
    }
  },
};
</script>

<style scoped>
/* Заглушка для Telegram медиа */
.tg-media-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px dashed #673AB7;
}

.tg-media-placeholder:hover {
  background: linear-gradient(135deg, #e8ecf1 0%, #d8dce1 100%);
  border-color: #0088cc;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #65676b;
}

.placeholder-icons {
  display: flex;
  gap: 12px;
  font-size: 32px;
  color: #fff;
}

.placeholder-text {
  font-size: 14px;
  color:#fff;
}

.placeholder-hint {
  font-size: 12px;
  color: #d7d7d7;
}

/* Индикатор загрузки */
.tg-media-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #f5f7fa;
  border-radius: 8px;
  width: 100%;
  gap: 12px;
  color: #65676b;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e4e6eb;
  border-top-color: #0088cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Ошибка загрузки */
.tg-media-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%);
  border-radius: 8px;
  cursor: pointer;
  gap: 8px;
  color: #dc2626;
  border: 1px dashed #fca5a5;
  transition: all 0.2s ease;
}

.tg-media-error:hover {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-color: #dc2626;
}

.tg-media-error i {
  font-size: 32px;
}

.tg-media-error .placeholder-hint {
  color: #9ca3af;
}
</style>

